import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.8125rem',
  lineHeight: 1.4,

  borderRadius: 6,
  minHeight: 32,
  padding: '4px 12px',

  boxShadow: 'none',
  letterSpacing: '0.01em',

  transition:
    'background-color 120ms ease, box-shadow 120ms ease, border-color 120ms ease, transform 80ms ease',

  '& .MuiButton-startIcon, & .MuiButton-endIcon': {
    marginTop: 0,
    marginBottom: 0,
  },

  /* -------- contained (primary banking CTA) -------- */
  '&.MuiButton-contained': {
    boxShadow: 'none',

    '&:hover': {
      boxShadow: '0 1px 3px rgba(16,24,40,0.18)',
    },

    '&:active': {
      boxShadow: '0 0 0 rgba(0,0,0,0)',
      transform: 'translateY(0.5px)',
    },
  },

  /* -------- outlined (secondary banking action) -------- */
  '&.MuiButton-outlined': {
    borderWidth: '1.5px',

    '&:hover': {
      borderWidth: '1.5px',
      backgroundColor: theme.palette.action.hover,
    },
  },

  /* -------- text buttons -------- */
  '&.MuiButton-text': {
    paddingLeft: 8,
    paddingRight: 8,
  },

  /* -------- keyboard focus (important in banking apps) -------- */
  '&.Mui-focusVisible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },

  /* -------- disabled -------- */
  '&.Mui-disabled': {
    opacity: 0.55,
  },

  /* -------- compact sizes -------- */
  '&.MuiButton-sizeSmall': {
    minHeight: 28,
    fontSize: '0.75rem',
    padding: '3px 10px',
  },

  '&.MuiButton-sizeLarge': {
    minHeight: 36,
    fontSize: '0.875rem',
    padding: '6px 16px',
  },
}));

const LsButton = ({
  children,
  loading = false,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  startIcon,
  endIcon,
  disabled,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      color={color}
      size={size}
      disabled={disabled || loading}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      {...props}
    >
      {loading && (
        <CircularProgress
          size={14}
          color="inherit"
          sx={{ mr: 1 }}
        />
      )}
      {children}
    </StyledButton>
  );
};

export default LsButton;
